import React, { createContext, useContext, useState, useEffect } from "react";

const OptionContext = createContext();

export const OptionProvider = ({ children }) => {
const [selectedOption, setSelectedOption] = useState(() => {
  const saved = localStorage.getItem("marketplaceAcc");
  return saved ? JSON.parse(saved) : null;
});
  // save to localStorage whenever option change
  useEffect(() => {
    if (selectedOption) {
      localStorage.setItem("marketplaceAcc", JSON.stringify(selectedOption));
    }
  }, [selectedOption]);

  return (
    <OptionContext.Provider value={{ selectedOption, setSelectedOption }}>
      {children}
    </OptionContext.Provider>
  );
};

export const useOption = () => useContext(OptionContext);
